import React from 'react';
import PropTypes from 'prop-types';
import { useIsMobile } from 'utils/hooks';
import { Dialog, Div, P } from 'components/Ui';
import { InfoIcon } from 'images';
import styles from './styles.scss';

const RecentActivityDialog = ({ open, setStatus }) => {
  const isMobile = useIsMobile();
  return (
    <Dialog
      size="small"
      fullScreen={isMobile}
      isAutoClose={false}
      isCloseIcon
      open={open}
      onClose={setStatus}
      aria-labelledby="dialog-title"
    >
      <div className={styles.container}>
        <div
          className={!isMobile ? styles.subContainer : styles.mobileContainer}
        >
          <div className={styles.imageContainer}>
            <img src={InfoIcon} alt=""></img>
          </div>
          <Div className={styles.headerContainer} id="dialog-title">
            What is my recent activity?
          </Div>
          <div className={styles.textContainer}>
            <P translationKey={'YourRecentActivity'}>
              Your recent activity is the amount of any transactions since your
              last invoice, such as product deliveries, rental fees, bottle
              deposits, credits, and payments.
            </P>
          </div>
        </div>
      </div>
    </Dialog>
  );
};

RecentActivityDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  setStatus: PropTypes.func.isRequired,
};

export default RecentActivityDialog;
